module.exports = __webpack_public_path__ + "img/pms7.7ed26edb.png";